module.exports = __webpack_public_path__ + "static/media/search.d391ce00.svg";